import { APICallV1 } from 'reactApp/api/APICall';

export class ExtraEmailCheckAPICall extends APICallV1 {
    _method = 'profile/get_email_state';
    _type = 'post';
    defaultData = this._defaultPayload;
}
